import { useRecordContext } from "react-admin";
import { Chip } from "@mui/material";

type AmountFieldProps<T> = {
  fieldName: keyof T;
  label?: string;
};

const StringArray = <T extends Record<string, unknown>>({
  fieldName,
  // @ts-expect-error - label is mandatory for React Admin column title
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  label,
}: AmountFieldProps<T>) => {
  const record = useRecordContext<T>();
  const values = record?.[fieldName];

  if (!Array.isArray(values) || values.length === 0) {
    return <Chip label="null" />;
  }

  return (
    <>
      {(values as string[]).map((el) => (
        <Chip key={el} label={el} />
      ))}
    </>
  );
};

export default StringArray;
